import { render } from "./LoaderSpinner.vue?vue&type=template&id=29d322d1&scoped=true"
import script from "./LoaderSpinner.vue?vue&type=script&lang=js"
export * from "./LoaderSpinner.vue?vue&type=script&lang=js"

import "./LoaderSpinner.vue?vue&type=style&index=0&id=29d322d1&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d322d1"]])

export default __exports__